/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `Mutation` - Mutation
 * * `Calvin News` - Calvin News
 * * `Assessment` - Assessment
 * * `Other` - Other
 * @export
 */
export const NotificationsTypeEnum = {
  mutation: 'Mutation',
  calvinNews: 'Calvin News',
  assessment: 'Assessment',
  other: 'Other',
} as const;
export type NotificationsTypeEnum = (typeof NotificationsTypeEnum)[keyof typeof NotificationsTypeEnum];

export function instanceOfNotificationsTypeEnum(value: any): boolean {
  for (const key in NotificationsTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(NotificationsTypeEnum, key)) {
      if ((NotificationsTypeEnum as Record<string, NotificationsTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NotificationsTypeEnumFromJSON(json: any): NotificationsTypeEnum {
  return NotificationsTypeEnumFromJSONTyped(json, false);
}

export function NotificationsTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsTypeEnum {
  return json as NotificationsTypeEnum;
}

export function NotificationsTypeEnumToJSON(value?: NotificationsTypeEnum | null): any {
  return value as any;
}
